export const CASH_TRANSACTION_REPORT_PATH = '/reports/cash-transaction';
export const BANK_TRANSACTION_REPORT_PATH = '/reports/bank-transaction';
export const TRADE_CURRENCY_REPORT_PATH = '/reports/trade-currency';
export const TRANSFER_BETWEEN_ACCOUNTS_REPORT_PATH =
  '/reports/transfer-between-accounts';
export const INTERBANK_TRANSACTION_REPORT_PATH =
  '/reports/interbank-transaction';
export const CHEQUE_REPORT_PATH = '/reports/cheque';
export const OUTGOING_OR_INCOMING_REPORT_PATH =
  '/reports/outgoing-incoming-draft';
export const DRAFT_CONDUCTION_REPORT_PATH = '/reports/draft-conduction';
export const COMMON_ACCOUNT_INFORMATION_REPORT_PATH =
  '/reports/account-information';
export const CUSTOMERS_LIST_REPORT_PATH = '/reports/customers-list';
export const CHEQUES_LIST_REPORT_PATH = '/reports/cheques-list';
export const DEBTOR_AND_CREDITOR_REPORT_PATH = '/reports/debtor-and-creditor';
export const BRANCH_ACCOUNT_REPORT_PATH = '/reports/branch-account';
export const BANK_BOOK_REPORT_PATH = '/reports/bank-book';
export const DRAFT_DOCUMENTS_LIST_REPORT_PATH = '/reports/draft-documents-list';
export const DRAFT_ORDER_LIST_REPORT_PATH = '/reports/draft-orders-list';
export const MISCELLANEOUS_REPORT_PATH = '/reports/draft-miscelaneous';
export const ACCOUNT_BALANCE_REPORT_PATH = '/reports/account-balance';
export const BRANCH_ACCOUNT_BALANCE_REPORT_PATH =
  '/reports/branch-account-balance';
export const CUSTOMER_CREDIT_ACCOUNTS_REPORT_PATH =
  '/reports/customer-credit-account';
export const TRADE_CURRENCIES_LIST_REPORT_PATH =
  '/reports/trade-currencies-list';
